// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"ad53dca5","318":"e6d9e227"}[chunkId] + ".chunk.css";
};